import { t } from 'i18next';
import { ReactNode } from 'react';

import { DataTableColumn } from '~components/DataTable/dataTableColumn';

// Pass a page's existing `field` so its saved layout keeps matching.
export default function actionsColumn<TRow>(
  renderCell: (row: TRow) => ReactNode,
  field = 'actions',
): DataTableColumn<TRow> {
  return {
    field,
    headerName: t('actions.actions'),
    hideable: false,
    pin: 'right',
    resizable: false,
    renderCell,
  };
}
